import { Helmet } from "react-helmet-async";

const SITE = "https://getlcshield.com";

// Per-page SEO: owns the unique, Google-critical signals (title, description, canonical).
// OG/Twitter defaults live statically in index.html for non-JS social scrapers.
export const Seo = ({ title, description, path, noindex = false, robots }) => {
  const url = path ? `${SITE}${path}` : null;
  const robotsContent = robots || (noindex ? "noindex, nofollow" : null);
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {url && <link rel="canonical" href={url} />}
      {robotsContent && <meta name="robots" content={robotsContent} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
    </Helmet>
  );
};

export default Seo;
